module.exports = __webpack_public_path__ + "img/mate9.5975cbd5.jpg";